import MoreOutlined from '@ant-design/icons/MoreOutlined';
import { MenuItemType, MenuDividerType } from 'antd/es/menu/interface';
import type { MenuInfo } from '@rc-component/menu/es/interface';
import { KeyboardEvent, MouseEvent } from 'react';

import { OpTableRecordType } from 'new-components/DLS/OpTableCore/types';
import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { OpDropdown } from 'new-components/DLS/OpDropdown/OpDropdown';

import './OpTableRowMenu.scss';

export type OpRowMenuItem<
  RecordType extends OpTableRecordType = OpTableRecordType,
> =
  | (Omit<MenuItemType, 'onClick'> & {
      onClick: (
        record: RecordType,
        e?: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>,
      ) => void;
    })
  | MenuDividerType;

export const OpTableRowMenu = ({
  isVisible = () => true,
  items,
  record,
}: {
  isVisible?: (record: OpTableRecordType) => boolean;
  items: OpRowMenuItem[];
  record: OpTableRecordType;
}) => {
  return isVisible(record) ? (
    <OpDropdown
      // Slight adjustment to account for absolute positioning
      align={{ offset: [0, -6] }}
      className="op-table__row-menu-dropdown"
      menu={{
        items: items.map((item) => {
          return {
            ...item,
            // onClick is not needed for menu dividers
            ...(item.type !== 'divider' && {
              onClick: ({ domEvent: event }: MenuInfo) => {
                item?.onClick?.(record, event);
              },
            }),
          };
        }),
      }}
      placement="bottomRight"
      trigger={['click']}
    >
      <div className="op-table__row-menu">
        <OpButton size="small" icon={<MoreOutlined />} />
      </div>
    </OpDropdown>
  ) : (
    // Return empty space to avoid empty column default: '--'
    ' '
  );
};
